import { render, staticRenderFns } from "./historyNotice.vue?vue&type=template&id=1d9b5c30&scoped=true"
import script from "./historyNotice.vue?vue&type=script&lang=js"
export * from "./historyNotice.vue?vue&type=script&lang=js"
import style0 from "./historyNotice.vue?vue&type=style&index=0&id=1d9b5c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9b5c30",
  null
  
)

export default component.exports